import {Component} from '@angular/core';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy-policy.html',
})

export class PrivacyPolicyCmp {
}
